import axios from 'axios';
import { getBaseUrl } from 'utils/DOM';

const redirectToMaintenancePage = () => {
  let env = '';
  let domain = document.location.hostname.split('.')[0];
  const locale = 'en_US'; // TODO: remove hardcode
  if (process.env.NODE_ENV !== 'production') {
    domain = 'consumer-qa1';
  }
  if (domain.split('-').length > 1) {
    env = '-' + domain.split('-')[1];
  }
  const maintenanceUrl = `//consumer${env}.xtime.com/maintenance/?locale=${locale}`;
  document.location.replace(maintenanceUrl);
};

const xws = service => {
  const baseURL = getBaseUrl();
  const client = axios.create({
    baseURL,
    headers: {
      Accept: 'application/json'
    }
  });
  client.interceptors.request.use(
    function(config) {
      service.requestCallback(service, config);
      return config;
    },
    err => {
      return Promise.reject(err);
    }
  );

  client.interceptors.response.use(
    function(response) {
      const { data, status } = response;
      service.responseCallback(service, response);
      if (data.success && status === 200) {
        return response;
      } else {
        let message = `Request to ${response.config.url} failed`;
        if (data.message) {
          message += ` with message: ${data.message}`;
        } else {
          message += ` with no message`;
        }
        throw new Error(message);
      }
    },
    err => {
      // TODO: handling errors
      if (err.response && err.response.status === 503) {
        redirectToMaintenancePage();
      }
      service.responseCallback(service);
      /* eslint-disable no-console */
      console.error(`%c Server ERROR: ${err}`, 'background: #f00; color: #fff');
      /* eslint-enable no-console */
      return Promise.reject(err);
    }
  );
  return client;
};

export default xws;



// WEBPACK FOOTER //
// ./src/api/xws/request.js